export const SELECT_BRANCH = 'SELECT_BRANCH'
export const LOGIN = 'LOGIN'
export const GET_USER_BRANCHES = 'GET_USER_BRANCHES'
export const SET_FEE = 'SET_FEE'
export const RESET_APP = 'RESET_APP'